import { DownloadDone } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  invoiceUrl: string;
};

function Invoice({ invoiceUrl }: Props) {
  const { t } = useTranslation();

  return (
    <Button
      variant="outlined"
      fullWidth
      onClick={() => window.open(invoiceUrl, "_blank")}
      startIcon={<DownloadDone />}
    >
      {t("common.shared.download-pdf")}
    </Button>
  );
}

export default Invoice;
